import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=9f537f0e&scoped=true&"
import script from "./Detail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Detail.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f537f0e",
  null
  
)

export default component.exports